/**
 * eSports betting — `/betting-gaming/esports-betting`
 */
import { ESPORTS_BETTING_SLUG, esportsBettingDefaultData } from "./esportsBettingData";
import {
  EsportsBettingArticlesTab,
  EsportsBettingMediaTab,
  EsportsBettingOverviewTab,
} from "./EsportsBettingDesign";

export const esportsBettingModule = {
  slug: ESPORTS_BETTING_SLUG,
  getDefaultData: () => esportsBettingDefaultData,
  Views: {
    overview: EsportsBettingOverviewTab,
    articles: EsportsBettingArticlesTab,
    media: EsportsBettingMediaTab,
  },
};
